import React from 'react';
import { ExternalLink, Loader2, RefreshCw, Send } from 'lucide-react';

// Kapı iki yerde çizilir: promosyon kodu ekranı ve deneme bonusu kartı
// (Promosyonlar sayfası). Metin amaca göre değişir, geri kalan akış aynıdır —
// iki kopya tutulsaydı biri düzeltilip diğeri unutulurdu.
const TELEGRAM_GATE_COPY = {
  promo: {
    login: 'Promosyon kodu alanını açmak için önce üye girişi yapın.',
    link: 'Kod girebilmek için Telegram hesabınızı bağlayın ve topluluğumuza katılın. Doğrulama tamamlanınca kod alanı açılır.',
    join: 'Hesabınız bağlı; promosyon kodu alanını açmak için topluluğumuza katılın.',
  },
  trial: {
    login: 'Bu deneme bonusunu almak için önce üye girişi yapın.',
    link: 'Bu deneme bonusunu almak için Telegram hesabınızı bağlayın ve topluluğumuza katılın.',
    join: 'Hesabınız bağlı; deneme bonusunu almak için topluluğumuza katılın.',
  },
  bonus: {
    login: 'Bu bonusu almak için önce üye girişi yapın.',
    link: 'Bu bonusu almak için Telegram hesabınızı bağlayın ve kanalımıza katılın.',
    join: 'Hesabınız bağlı; bonusu almak için Telegram kanalımıza katılın, sonra "Üyeliği doğrula"ya dokunun.',
  },
  prediction: {
    login: 'Tahmin göndermek için önce üye girişi yapın.',
    link: 'Bu etkinliğe katılmak için Telegram hesabınızı bağlayın ve topluluğumuza katılın. Doğrulama tamamlanınca tahmin formu açılır.',
    join: 'Hesabınız bağlı; tahmin formunu açmak için topluluğumuza katılın.',
  },
  both: {
    login: 'Promosyon kodu kullanmak veya deneme bonusu almak için önce üye girişi yapın.',
    link: 'Kod kullanmak ve deneme bonusu almak için Telegram hesabınızı bağlayın ve topluluğumuza katılın.',
    join: 'Hesabınız bağlı; promosyon kodu ve deneme bonusunu açmak için topluluğumuza katılın.',
  },
};

const PromoTelegramGate = ({
  user, loading, status, linking, linkUrl, onLink, onRefresh,
  purpose = 'promo', title = '',
}) => {
  const copy = TELEGRAM_GATE_COPY[purpose] || TELEGRAM_GATE_COPY.promo;
  return (
  <section className="pusu-card mb-6 p-5" aria-labelledby="promo-telegram-title">
    <div className="flex items-start gap-3">
      <div className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-[var(--pusu-gold)]/10 text-[var(--pusu-gold)]">
        <Send size={19} />
      </div>
      <div className="min-w-0 flex-1">
        <h2 id="promo-telegram-title" className="font-black gold-text">
          {title || 'Telegram üyeliğinizi doğrulayın'}
        </h2>
        {!user ? (
          <p className="mt-1 text-sm text-gray-400">
            {copy.login}
          </p>
        ) : loading ? (
          <p className="mt-2 flex items-center gap-2 text-sm text-gray-400">
            <Loader2 size={15} className="animate-spin" />
            Telegram üyeliğiniz denetleniyor…
          </p>
        ) : !status?.configured ? (
          <p className="mt-1 text-sm text-gray-400">
            Telegram doğrulaması şu anda kullanılamıyor. Lütfen daha sonra
            tekrar deneyin.
          </p>
        ) : !status.linked ? (
          <>
            <p className="mt-1 text-sm text-gray-400">
              {copy.link}
            </p>
            <button
              type="button"
              onClick={onLink}
              disabled={linking}
              className="gold-btn mt-4 flex items-center gap-2 rounded-lg px-4 py-2.5 text-sm disabled:opacity-50"
            >
              {linking
                ? <Loader2 size={15} className="animate-spin" />
                : <ExternalLink size={15} />}
              Telegram hesabımı bağla
            </button>
            {linkUrl && (
              <a
                href={linkUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-3 block text-xs text-[var(--pusu-gold)] underline"
              >
                Telegram açılmadıysa buraya dokunun
              </a>
            )}
          </>
        ) : (
          <>
            <p className="mt-1 text-sm text-gray-400">
              {status.error
                ? 'Telegram üyeliği şu anda doğrulanamadı. Tekrar deneyin.'
                : copy.join}
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              {status.group_url && (
                <a
                  href={status.group_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="gold-btn flex items-center gap-2 rounded-lg px-4 py-2.5 text-sm"
                >
                  <ExternalLink size={15} />
                  {purpose === 'bonus' ? 'Telegram kanalına katıl' : 'Telegram topluluğuna katıl'}
                </a>
              )}
              <button
                type="button"
                onClick={onRefresh}
                className="gold-outline-btn flex items-center gap-2 rounded-lg px-4 py-2.5 text-sm"
              >
                <RefreshCw size={15} />
                Üyeliği doğrula
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  </section>
  );
};

export default PromoTelegramGate;
